import { render, staticRenderFns } from "./DebtCards.vue?vue&type=template&id=e16a8854&"
import script from "./DebtCards.vue?vue&type=script&lang=js&"
export * from "./DebtCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports